<template>

	<footer>

      <div class="follow">
        <div class="content">
          <h4> Connect with us </h4>
          <ul class="social">
            <li><a href="https://twitter.com/GLOBOCAN_GCO" target="_blank"><i class="fab fa-twitter"></i></a></li>
            <li><a href="https://www.youtube.com/channel/UCw1sEvFsKqLLRmKQdaOSs9A" target="_blank"><i class="fab fa-youtube"></i></a></li>
            <li><a href="https://www.linkedin.com/company/102821/" target="_blank"><i class="fab fa-linkedin"></i></a></li>
            <li><a href="https://www.iarc.who.int/cards_page/iarcrssfeeds/" target="_blank"><i class="fas fa-rss"></i></a></li>
          </ul>
        </div>
      </div>

      <div class="content">
        <div class="footer">

          <div class="row" id="footer-row">
            <div class="col-md-9">   

              <h5 class="footer_title"> The Global Cancer Observatory </h5>

              <div class="container-footer-gco">
                <div class="footer-gco-item" v-for="(link,cpt) in footer_gco_links" v-bind:key="link.url">
                  <a :href="link.url" target="_blank">
                    <img class="img-fluid" :src="link.pic">
                  </a>
                </div>
              </div>

              
            </div>

            <div class="col-md-3">
              <h5 class="footer_title"> Contact </h5>

              <ul class="footer_links">
                <li>
                   <i class="fas fa-home"></i>
                   <span class="txt_contact">
                    25 avenue Tony Garnier<br/> 
                    CS 90627 <br/>
                    69366 LYON CEDEX 07 France
                  </span> 
                </li>
                <li id="contact_us">
                   <a href="mailto:csu@iarc.who.int"><i class="fas fa-envelope"></i> <span class="txt_contact">Contact us</span> </a>
                </li>
                <li class="terms">
                   <a href="http://publications.iarc.who.int/Terms-Of-Use" target="_blank">Terms of use </a>
                </li>
                <li class="terms">
                   <a href="https://www.iarc.who.int/privacy-policy/" target="_blank"> Privacy Policy </a> 
                </li>
              </ul>
            </div>
          </div>

          <div class="copyright">© <a href="https://www.iarc.who.int/copyright-notice/" target="_blank"><strong>IARC</strong> 1965-{{ year }} — All Rights Reserved</a></div>
        </div>
      </div>
    </footer>

</template>

<script>

export default {
	name : 'IarcFooter', 
	props : {
    is_overtime : false
	} , 
	data : function(){	
  	return {
    		year : new Date().getFullYear() ,
        footer_gco_links : []
   	}
  },
  mounted(){
    // console.log("this.is_overtime",this.is_overtime);

    this.footer_gco_links = [
      { pic : 'https://gco.iarc.who.int/img/today.png' , url : 'https://gco.iarc.who.int/today/' },
      { pic : 'https://gco.iarc.who.int/img/over_time.png' , url : 'https://gco.iarc.who.int/overtime/' },
      { pic : 'https://gco.iarc.who.int/img/causes.png' , url : 'https://gco.iarc.who.int/causes/' },
      { pic : 'https://gco.iarc.who.int/img/survival.png' , url : 'https://gco.iarc.who.int/survival/' }
    ]

    if ( this.is_overtime == true )
    {
      this.footer_gco_links = [
        { pic : 'https://gco.iarc.who.int/img/today.png' , url : 'https://gco.iarc.who.int/today/' },
        { pic : 'https://gco.iarc.who.int/img/tomorrow.png' , url : 'https://gco.iarc.who.int/tomorrow/' },
        { pic : 'https://gco.iarc.who.int/img/causes.png' , url : 'https://gco.iarc.who.int/causes/' },
        { pic : 'https://gco.iarc.who.int/img/survival.png' , url : 'https://gco.iarc.who.int/survival/' }
      ]
    }

  }
}
</script>

<style lang="scss">

#footer-row{
  margin-right: 0px;
  margin-left: 0px;
}

.container-footer-gco{
  display: flex;
  gap: 30px;
  margin: 30px 0 ;
  .footer-gco-item{
    flex-grow: 1;
    img{
    }
  }
}

</style>

